import { apiClient, getAuthId, getToken, getUserId } from '@devd-client/api';

export const postTeamComparisonMetrics = (params: any) => {
  return apiClient(
    `/v1/user/${getUserId()}/preference/team_comparison_metrics`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params),
    }
  );
};

export const getUser = (): Promise<any> =>
  apiClient(`/v2/account/user/${getAuthId()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
